import { digitsThree } from "../price";

export function loanCalculation({ values, month, loan, type }) {
  const inputData = [];

  if (type == "all") {
    for (let i = 0; i < month.length; i++) {
      inputData.push({
        month: month[i],
        amountOfInstallment: digitsThree(values?.money),
        totalAmountOfLoan: digitsThree(values?.money * month[i]),
        rewardRatesRequired: digitsThree(
          (values?.money * month[i] * 122) / 100
        ),
        promissoryNote: digitsThree(
          Math.floor((values?.money * month[i] * month[i]) / 12)
        ),
        costOfPurchasingRates: digitsThree(
          Math.floor(
            (values?.buyLoan *
              Math.floor((values?.money * month[i] * month[i]) / 12)) /
              1000000
          )
        ),
        SuggestedCashCost: digitsThree(
          Math.floor(
            (loan?.number *
              Math.floor((values?.money * month[i] * month[i]) / 12)) /
              1000000
          )
        ),
        SuggestedChequeCost: digitsThree(
          Math.floor(
            ((loan?.chequeNumber + (24 - month[i]) * loan?.difference) *
              Math.floor((values?.money * month[i] * month[i]) / 12)) /
              1000000
          )
        ),
      });
    }
  } else {
    inputData.push({
      month: values.month,
      amountOfInstallment: digitsThree(values?.money),
      totalAmountOfLoan: digitsThree(values?.money * values.month),
      rewardRatesRequired: digitsThree(
        (values?.money * values.month * 122) / 100
      ),
      promissoryNote: digitsThree(
        Math.floor((values?.money * values.month * values.month) / 12)
      ),
      costOfPurchasingRates: digitsThree(
        Math.floor(
          (values?.buyLoan *
            Math.floor((values?.money * values.month * values.month) / 12)) /
            1000000
        )
      ),
      SuggestedCashCost: digitsThree(
        Math.floor(
          (loan?.number *
            Math.floor((values?.money * values.month * values.month) / 12)) /
            1000000
        )
      ),
      SuggestedChequeCost: digitsThree(
        Math.floor(
          (loan?.chequeNumber *
            Math.floor((values?.money * values.month * values.month) / 12)) /
            1000000
        )
      ),
    });
  }
  return inputData
}
